import * as React from 'react';
import { Main } from './main';

const PreLoaderComponent = ({
  dispatch,
  emailBatches,
  count,
  order,
  loading,
}: any) => {
  return (
    <Main
      dispatch={dispatch}
      emailBatches={emailBatches}
      count={count}
      order={order}
      loading={loading}
    />
  );
};

export const PreLoader = React.memo(PreLoaderComponent);
